<template>
    <div>
        <div class="flex flex-wrap justify-between items-center mb-4">
            <h5>Email</h5>
        </div>
        <div class="table-responsive">
            <table class="light_blue_table w-full">
                <tbody>
                    <tr>
                        <td>
                            <div class="flex items-center">
                                <span class="material-icons-outlined small_icon">email</span>
                                Email
                            </div>
                        </td>
                        <td>{{email}}</td>
                        <!-- <td>
                            <vs-dropdown>
                                <vs-button class="btn-drop" type="flat" icon="more_vert"></vs-button>
                                <vs-dropdown-menu>
                                    <vs-dropdown-item>
                                        Edit
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>     
    </div>
</template>
<script>
export default {
  props:{
    email:{
      default:''
    }
  },
  methods:{

  }
}
</script>